import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { UserModel } from 'src/app/services/user-model';
import { UserService, UserType } from 'src/app/services/user.service';

declare var $: any;

@Component({
	selector: 'app-main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {

	user$: Observable<UserType>;

	title_page: any = '';

	products = [
		{
			name: 'QH Organizaciones',
			url: 'home',
			image: '/assets/img/demo.png'
		}
	];

	organizations = null;

	constructor(
		private userService: UserService,
		public userModel: UserModel
	) {
		this.user$ = this.userService.currentUserSubject.asObservable();
	}

	ngOnInit() {
	}

	ngAfterViewInit(): void {

    //custom mat sort functionality
    var headerContainers = document.getElementsByClassName('mat-sort-header-container');
    var counter=[0,0,0,0,0,0,0,0,0,0];

    for (let i = 0; i < headerContainers.length; i++) {
      headerContainers[i].addEventListener("click", function() {
        if(counter[i] >= 1){
        }else{
          counter=[0,0,0,0,0,0,0,0,0,0];
        }
        counter[i]++;
        if(counter[i] === 3){
          for (let j = 0; j < headerContainers.length; j++) {
            headerContainers[j].children[1].classList.remove('active');
          }
          counter[i] = 0;
        }else{
          for (let j = 0; j < headerContainers.length; j++) {
            headerContainers[j].children[1].classList.remove('active');
          }
          headerContainers[i].children[1].classList.add('active');
        }
      })
    }

		$(function() {
			$('.toogle_dropdown').on('click', function(this: any) {
				console.log(this);
				$(this).next('.dropdown').slideToggle();
			});

			$('.toogle_dropdown_a').on('click', function(this: any) {
				$('.dropdown').slideUp()
			});

			$(document).on('click', function(e: any) {
				var target = e.target;
				if (!$(target).is('.toogle_dropdown') && !$(target).parents().is('.toogle_dropdown')) {
					$('.dropdown').slideUp()
				}
			});

			$('.content_header-space').css('padding-top', `${$('.header__menu').outerHeight()}px`);

			$('.btn_a-sidebar').on('click', function() {
				$('.bg__sidebar_left').fadeOut();
				$('.sidebar_left').removeClass('active');
			});
		});

		$('.btn__sidebar, .bg__sidebar_left').on('click', function() {
			$('.bg__sidebar_left').fadeToggle();
			$('.sidebar_left').toggleClass('active');
		});
	}

}
